document.addEventListener("DOMContentLoaded", () => {
  // 判断元素是否在视口内
  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= -el.offsetHeight / 2 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + el.offsetHeight / 2
    );
  }
  function observeElement(element, callback) {
    const observer = new IntersectionObserver((entries, observerInstance) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          callback();
          // 只执行一次，停止观察
          observerInstance.unobserve(entry.target);
        }
      });
    }, {
      // 视口外 1/2 高度以内触发
      root: null,
      threshold: 0.5
    });
    // 如果已经在视口内,立即执行回调
    if (isElementInViewport(element)) {
      callback();
      return;
    }
    observer.observe(element);
  }

  const sections = document.querySelectorAll('.collection-nav-list');
  for (const section of sections) {
    observeElement(section, () => handleInViewport(section));
  }

function handleInViewport(section) {
  function initSlick(_slick) {
    // On init event
    _slick.on('init', function(event, slick){
      // ADA: Handle slick carousel markup
      let $slider = slick.$slider;
      let $sliderItems = slick.$slides;
      let slideCount = slick.slideCount;
      if((window.innerWidth > 1200 && slideCount <= 5) || (window.innerWidth <= 1200 && window.innerWidth > 1000 && slideCount <= 4) || (window.innerWidth <= 1000 && window.innerWidth > 767 && slideCount <= 3) || (window.innerWidth <= 767 && slideCount <= 2)) {
        slick.unslick();
        $slider.removeAttr('role').removeAttr('aria-label');
        $slider.prev('.sr-only').remove();
        setTimeout(()=> {$sliderItems.removeAttr('aria-hidden').removeAttr('tabindex');}, 1);
      }
    });
    _slick.slick({
      infinite: true,
      draggable: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      prevArrow:
        '<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="collection-nav-list-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="collection-nav-list-prev">Explore Experience Prev</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>',
      nextArrow:
        '<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="collection-nav-list-next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="collection-nav-list-next">Explore Experience Next</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            centerMode: true,
            arrows: false,
            dots: true,
            slidesToShow: 2,
            centerPadding: '30px',
          },
        },
      ],
    });
  }
  initSlick($(section.querySelector('.collection-nav-list-box')));
  }
});
